<template>
  <div class="match-bg bg-no-repeat bg-center bg-cover leading-9 pt-10 md:pt-24 pb-96 md:pb-64">
    <section
      class="container flex flex-col content-center text-center text-white w-full md:w-6/12 overflow-hidden sm:overflow-visible"
    >
      <h1 class="flex justify-center" :title="page.title">
        <img
          :src="require('~/assets/img/match/match.svg')"
          :alt="page.title"
          class="transform scale-140 sm:scale-125 md:scale-100 pt-8"
        >
      </h1>
      <read-btn/>
      <p class="hidden md:block">
        Datalead is specialist in het koppelen en verbinden van software.
        Zo kunnen wij {{ firstProduct.title }} koppelen met {{ secondProduct.title }}.
        Vraag vrijblijvend advies aan onze specialisten.
      </p>
      <section class="grid grid-rows-auto grid-cols-6 md:grid-cols-7 md:grid-rows-1 pt-6 sm:pt-24">
        <div class="md:hidden row-start-1 col-start-1 col-end-7 text-left mb-4">
          <h3>Over {{ firstProduct.title }}</h3>
          <p v-html="firstProduct.text"/>
        </div>
        <div class="hidden md:flex col-start-1 col-end-4 justify-end mr-12">
          <figure v-if="firstProduct.favicon" class="icon-l flex relative z-10">
            <img :src="firstProduct.favicon" :alt="firstProduct.title" class="mr-3 object-contain">
          </figure>
        </div>
        <div class="row-start-2 md:row-start-1 col-start-3 md:col-start-4 col-end-5 flex justify-center">
          <div class="btn-round-large relative">
            <font-awesome-icon :icon="['far', 'link']" size="lg"/>
          </div>
        </div>
        <div class="md:hidden row-start-3 col-start-1 col-end-7 text-left mt-4 mb-24">
          <h3>Over {{ secondProduct.title }}</h3>
          <p v-html="secondProduct.text"/>
        </div>
        <div class="hidden md:flex col-start-5 col-end-8 ml-12">
          <figure v-if="secondProduct.favicon" class="icon-r flex relative z-10">
            <img :src="secondProduct.favicon" :alt="secondProduct.title" class="ml-3 object-contain">
          </figure>
        </div>
      </section>
    </section>
    <section class="hidden md:flex container text-white justify-center w-8/12">
      <div class="grid grid-cols-7 pt-16 pb-24">
        <div class="col-start-1 col-end-4 text-right">
          <h3>Over {{ firstProduct.title }}</h3>
          <p v-html="firstProduct.text"/>
        </div>
        <div class="col-start-5 col-end-8 text-left">
          <h3>Over {{ secondProduct.title }}</h3>
          <p v-html="secondProduct.text"/>
        </div>
      </div>
    </section>
    <section class="hidden md:block container text-center text-white w-6/12">
      <h3>{{ firstProduct.title }} met {{ secondProduct.title }} koppelen?</h3>
      <div v-html="introduction"/>
      <div class="grid grid-cols-2 pt-8">
        <nuxt-link to="#examples" class="no-underline text-right pr-6 hover:text-white">
          <span class="btn-round inline-flex hover:opacity-100">
            <font-awesome-icon :icon="['fas', 'long-arrow-alt-down']"/>
          </span>
          <span class="ml-3">Voorbeelden</span>
        </nuxt-link>
        <nuxt-link to="#benefits" class="no-underline text-left pl-6 hover:text-white">
          <span class="btn-round inline-flex hover:opacity-100">
            <font-awesome-icon :icon="['fas', 'long-arrow-alt-down']"/>
          </span>
          <span class="ml-3">Voordelen</span>
        </nuxt-link>
      </div>
    </section>
  </div>
</template>

<script>
import page from '~/plugins/mixins/page';
import ReadBtn from '~/layouts/partials/ReadBtn';

export default {
  components: {
    ReadBtn,
  },
  mixins: [page],
  props: {
    firstProduct: {
      type: Object,
      default: () => ({}),
    },
    secondProduct: {
      type: Object,
      default: () => ({}),
    },
    introduction: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="sass" scoped>
.match-bg
  background-image: url("~assets/img/bg-match.svg")

.icon-l::before
  position: absolute
  content: ''
  top: -28px
  right: -30px
  bottom: -40px
  left: -50px
  background: url("~assets/img/match/bubble-left.svg") no-repeat
  background-size: contain
  z-index: -1

.icon-r::before
  position: absolute
  content: ''
  top: -26px
  right: -48px
  bottom: -34px
  left: -30px
  background: url("~assets/img/match/bubble-right.svg") no-repeat
  background-size: contain
  z-index: -1

.btn-round-large
  &::before
    position: absolute
    content: ''
    left: -54px
    right: 46px
    border-top: 8px dotted #e95b1b
    z-index: 30

  &::after
    position: absolute
    content: ''
    left: 46px
    right: -54px
    border-top: 8px dotted #e95b1b
    z-index: 30
</style>
